import { __exports as r } from "./index141.js";
var n;
function a() {
  if (n) return r;
  n = 1;
  var t = /\d{10}/;
  return r.is = function(e) {
    return t.test(e);
  }, r.parse = function(e) {
    var s = parseInt(e, 10) * 1e3;
    return new Date(s);
  }, r;
}
export {
  a as __require
};
//# sourceMappingURL=index130.js.map
